module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.show_landing) ? _c('div', {
    staticClass: "main-wrap",
    staticStyle: {
      "background-color": "#fafafa"
    },
    attrs: {
      "id": "wrap"
    }
  }, [(((Object.keys(_vm.menu_tab_inner_view).length == 0) || (_vm.menu_tab_inner_view.length == 0) || (_vm.menu_tab_inner_view['']))) ? _c('div', {
    staticStyle: {
      "margin-bottom": "25em"
    }
  }, [_c('div', {
    key: _vm.headerComponentKey,
    staticClass: "header-wrap-sticky",
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pager",
    staticStyle: {
      "background-color": "none",
      "margin-top": "3.5em",
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "background-color": "none"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container htro"
  }, [_c('h2', {
    staticClass: "ttro",
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "24px"
    }
  }, [_vm._v("\r\n                @ " + _vm._s(_vm.sellpoint.business_name) + "\r\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "container card",
    staticStyle: {
      "margin": "0",
      "padding": "1em",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin-top": "-0.29em",
      "margin-left": "-0.8em",
      "color": "#000000"
    }
  }, [_c('ul', _vm._l((_vm.categories), function(data, index) {
    return _c('li', {
      staticClass: "card-col-2",
      staticStyle: {
        "background": "#ffffff",
        "border-radius": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "block",
        "padding": "5px 1em",
        "padding-bottom": "0"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(data.category_name) + " "), _c('br')])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container card",
    staticStyle: {
      "margin": "0",
      "padding": "1em",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin-top": "-0.29em",
      "margin-left": "-0.8em",
      "color": "#000000"
    }
  }, [_c('ul', _vm._l((_vm.categories), function(data, index) {
    return _c('li', {
      staticClass: "card-col-2",
      staticStyle: {
        "background": "#ffffff",
        "border-radius": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "block",
        "padding": "5px 1em",
        "padding-bottom": "0"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(data.category_name) + " "), _c('br')])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _vm._l((_vm.categories), function(data, cindex) {
    return _c('div', {
      staticClass: "card",
      staticStyle: {
        "margin": "1.5em",
        "margin-top": "1.8em"
      }
    }, [_c('div', {
      staticStyle: {
        "border-radius": "1px",
        "border": "none",
        "margin": "0em",
        "margin-top": "1em"
      }
    }, [_c('h4', [_vm._v(_vm._s(data.category_name))]), _vm._v(" "), _c('div', {
      staticClass: "container",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "category-slide",
      staticStyle: {
        "border-radius": "1px",
        "border": "none",
        "margin-top": "-0.29em",
        "margin-left": "-0.8em",
        "color": "#000000"
      }
    }, [_c('ul', _vm._l((_vm.products), function(product, index) {
      return _c('li', [(Object.keys(product.product_images).length > 0) ? _c('div', {
        staticClass: "col-xs-12",
        staticStyle: {
          "margin": "0",
          "padding": "0.31em"
        }
      }, [_c('a', {
        staticClass: "card-link",
        on: {
          "click": function($event) {
            _vm.setProductView(product, index, product.product_items[0], 0)
          }
        }
      }, [_c('div', {
        staticClass: "card",
        staticStyle: {
          "padding": "0.2em",
          "margin-bottom": "1em"
        }
      }, [_c('div', {
        staticClass: "card-col-img",
        staticStyle: {
          "background-repeat": "no-repeat",
          "background-size": "cover"
        },
        style: ({
          'background-image': 'url(' + product.product_images[0].product_image + ')'
        })
      }), _vm._v(" "), _c('div', {
        staticClass: "card-details",
        staticStyle: {
          "z-index": "1",
          "height": "75px",
          "border-radius": "0 0 14px 14px",
          "background": "#ffffff",
          "padding": "1em",
          "padding-top": "0.6em"
        }
      }, [_c('div', {
        staticClass: "prd-name",
        staticStyle: {
          "font-size": "16px",
          "text-align": "left",
          "background": "#ffffff"
        }
      }, [_c('span', {
        staticStyle: {
          "float": "left"
        }
      }, [_c('span', [_c('b', [_vm._v(_vm._s(product.product_name))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "right",
          "display": "block"
        }
      }, [_c('div', {
        staticStyle: {
          "display": "none"
        }
      }, [_c('span', {
        staticStyle: {
          "display": "block"
        },
        attrs: {
          "id": 'prdQty' + index
        }
      }, [_c('button', {
        staticClass: "btn sp-button-02-lt",
        staticStyle: {
          "padding": "3px 3px",
          "line-height": "0.2"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setOrderQuantity(1, 1, 'sub', index, product.product_items[0], 0)
          }
        }
      }, [_c('span', {
        staticStyle: {
          "font-size": "38px"
        }
      }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
        staticStyle: {
          "padding": "0 0.61em"
        }
      }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-02-lt",
        staticStyle: {
          "padding": "3px 3px",
          "line-height": "0.6"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setOrderQuantity(1, 1, 'add', index, product.product_items[0], 0)
          }
        }
      }, [_c('span', {
        staticStyle: {
          "font-size": "28px"
        }
      }, [_vm._v("+")])])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
        staticClass: "btn sp-button-02-lt",
        staticStyle: {
          "padding": "3px 3px",
          "line-height": "0.6"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setAddOrderItems(1, product.product_items[0], index, 0);
            _vm.toggleSingleComponent('prdQty' + index)
          }
        }
      }, [_vm._m(0, true)]) : _c('button', {
        staticClass: "btn sp-button-02-lt",
        staticStyle: {
          "padding": "3px 3px",
          "line-height": "0.6",
          "border": "#d8d8d8 solid"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setAddOrderItems(1, product.product_items[0], index, 0);
            _vm.toggleSingleComponent('prdQty' + index)
          }
        }
      }, [_c('span', {
        staticStyle: {
          "font-size": "18px"
        }
      }, [_vm._v("  ")])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "display": "block"
        }
      }, [(_vm.checkProductOrderItems(product)) ? _c('button', {
        staticClass: "btn sp-button-02-lt",
        staticStyle: {
          "padding": "3px 3px",
          "line-height": "0.6"
        },
        attrs: {
          "type": "button"
        }
      }, [_vm._m(1, true)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
        staticStyle: {
          "clear": "both"
        }
      })])])])]) : _vm._e()])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "clear:both"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "clear:both"
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), (_vm.shop_layout == 2) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container htro"
  }, [_c('h2', {
    staticClass: "ttro",
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "24px"
    }
  }, [_vm._v("\r\n                @ " + _vm._s(_vm.sellpoint.business_name) + "\r\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "container card",
    staticStyle: {
      "margin": "0",
      "padding": "1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin-top": "-0.29em",
      "margin-left": "-0.8em",
      "color": "#000000"
    }
  }, [_c('ul', _vm._l((_vm.categories), function(data, index) {
    return _c('li', {
      staticClass: "card-col-2",
      staticStyle: {
        "background": "#ffffff",
        "border-radius": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "block",
        "padding": "5px 1em",
        "padding-bottom": "0"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(data.category_name) + " "), _c('br')])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "1.5em",
      "margin-top": "-1.8em"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin": "0em",
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return (Object.keys(product.product_images).length > 0) ? _c('div', {
      staticClass: "col-xs-6",
      staticStyle: {
        "margin": "0",
        "padding": "0.31em"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setProductView(product, index, product.product_items[0], 0)
        }
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      style: ({
        'background-image': 'url(' + product.product_images[0].product_image + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "card-details",
      staticStyle: {
        "z-index": "1",
        "height": "75px",
        "border-radius": "0 0 14px 14px",
        "background": "#ffffff",
        "padding": "1em",
        "padding-top": "0.6em"
      }
    }, [_c('div', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left",
        "background": "#ffffff"
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('span', [_c('b', [_vm._v(_vm._s(product.product_name))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "display": "block"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "id": 'prdQty' + index
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_vm._m(2, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "block"
      }
    }, [(_vm.checkProductOrderItems(product)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._m(3, true)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.shop_layout == 3) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "container htro"
  }, [_c('h2', {
    staticClass: "ttro",
    staticStyle: {
      "font-weight": "bolder",
      "font-size": "24px"
    }
  }, [_vm._v("\r\n                @ " + _vm._s(_vm.sellpoint.business_name) + "\r\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "container card",
    staticStyle: {
      "margin": "0",
      "padding": "1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "category-slide",
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin-top": "-0.29em",
      "margin-left": "-0.8em",
      "color": "#000000"
    }
  }, [_c('ul', _vm._l((_vm.categories), function(data, index) {
    return _c('li', {
      staticClass: "card-col-2",
      staticStyle: {
        "background": "#ffffff",
        "border-radius": "5px"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "block",
        "padding": "5px 1em",
        "padding-bottom": "0"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(data.category_name) + " "), _c('br')])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "1.5em",
      "margin-top": "-1.8em"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "1px",
      "border": "none",
      "margin": "0em",
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "background-color": "#ffffff"
    }
  }, _vm._l((_vm.products), function(product, index) {
    return (Object.keys(product.product_images).length > 0) ? _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "margin": "0",
        "padding": "0.31em"
      }
    }, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setProductView(product, index, product.product_items[0], 0)
        }
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "padding": "0.2em",
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "card-colxx",
      staticStyle: {
        "margin-bottom": "-1em",
        "z-index": "5",
        "background": "#ffffff",
        "border-radius": "14px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "card-col-img",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-details",
      staticStyle: {
        "z-index": "1",
        "height": "75px",
        "border-radius": "0 0 14px 14px",
        "background": "#ffffff",
        "padding": "1em",
        "padding-top": "0.6em"
      }
    }, [_c('div', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px",
        "text-align": "left",
        "background": "#ffffff"
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('span', [_c('b', [_vm._v(_vm._s(product.product_name))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "display": "block"
      }
    }, [_c('div', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('span', {
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "id": 'prdQty' + index
      }
    }, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 1, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_vm._m(4, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
          _vm.toggleSingleComponent('prdQty' + index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "block"
      }
    }, [(_vm.checkProductOrderItems(product)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
        }
      }
    }, [_vm._m(5, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(1, product.product_items[0], index, 0);
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])])]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clear:both"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.set_order_list.length == 0) ? _c('component-footer') : _vm._e()], 1) : (_vm.menu_tab_inner_view['addToList']) ? _c('div', {
    staticStyle: {
      "margin-bottom": "25em"
    }
  }, [(_vm.product && (Object.keys(_vm.product).length > 0)) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "background-color": "#ffffff",
      "margin-top": "3em"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.8em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "0",
      "margin-bottom": "15em",
      "padding": "1em"
    }
  }, [_c('div', {
    staticClass: "card x-img-bg",
    staticStyle: {
      "background-repeat": "no-repeat",
      "background-size": "contain"
    },
    style: ({
      'background-image': 'url(' + _vm.product.product_images[0].product_image + ')'
    }),
    attrs: {
      "id": "dbgg"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pLess"
    }
  }, [_c('span', {
    staticClass: "max-lines"
  }, [_vm._v("Create stunning Food Delivery App designed by Lena Smirnova. \r\n              Connect with them on Dribbble; the global community for designers and \r\n              creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n              Connect with them on Dribbble; the global community for designers and \r\n              creative professionals. \r\n              Create stunning Food Delivery App designed by Lena Smirnova. \r\n              Connect with them on Dribbble; the global community for designers and \r\n              creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n              Connect with them on Dribbble; the global community for designers and \r\n              creative professionals.")]), _vm._v(".."), _c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('pMore', 'pLess')
      }
    }
  }, [_vm._v("more")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "pMore"
    }
  }, [_vm._v("A Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals. \r\n                Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals...."), _c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('pMore', 'pLess')
      }
    }
  }, [_vm._v("less")])])]), _vm._v(" "), (_vm.product.product_items && (Object.keys(_vm.product.product_items).length > 1)) ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-bottom": "15em"
    }
  }, [_c('h4', [_vm._v("Please select from (" + _vm._s(_vm.product.product_items.length) + ") below options")]), _vm._v(" "), _vm._l((_vm.product.product_items), function(item, product_item_index) {
    return _c('div', {}, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setProductItem(item, product_item_index);
        }
      }
    }, [_c('div', {
      staticClass: "card col-xs-4 mp0",
      staticStyle: {
        "margin-bottom": "1em",
        "padding": "1em 0.5em",
        "border": "1px solid #eee",
        "border-radius": "3px"
      }
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      key: _vm.componentKey,
      staticClass: "card"
    }, [(_vm.checkOrderItems(item)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._m(6, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])]), _vm._v(" "), _c('p', [(product_item_index == 0) ? _c('span', [_c('b', [_vm._v("Main")])]) : _c('span', [_vm._v(_vm._s(item.product_item_service_tag))])]), _vm._v(" "), _c('p', [_vm._v("₦‎" + _vm._s(item.product_item_price_f))])])])])])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "border": "none",
      "width": "90%",
      "bottom": "5em",
      "z-index": "7"
    }
  }, [(_vm.product_item && (Object.keys(_vm.product_item).length > 0)) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', [((Object.keys(_vm.product.product_items).length == 1)) ? _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "background-color": "#eee",
      "border-radius": "45px 45px 45px 45px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddOrderItems(1, _vm.product_item, _vm.product_index, _vm.product_item_index);
        _vm.setMenuTabInnerView('');
      }
    }
  }, [_vm._v("Add to List")]) : _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "background-color": "#eee",
      "border-radius": "45px 45px 45px 45px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Add to List")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), ((_vm.product.product_images && (_vm.product.product_images.length > 0)) && (_vm.product.product_images[0].product_image != '' && _vm.product.product_images[0].product_image != 'error')) ? _c('img', {
    key: _vm.componentKey,
    staticClass: "pb_img",
    staticStyle: {
      "z-index": "1",
      "opacity": "0"
    },
    attrs: {
      "id": "xmg",
      "src": _vm.img_product_url + _vm.product.product_images[0].product_image,
      "alt": ""
    }
  }) : _vm._e()]) : _vm._e()]) : (_vm.menu_tab_inner_view['processOrder']) ? _c('div', {
    staticStyle: {
      "margin-bottom": "25em"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "background-color": "#ffffff",
      "margin-top": "3em"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.8em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._m(7), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.8em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setOrderAddons'
      }
    }
  }, [_vm._v("Proceed")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#000000",
      "padding": "0.6em 0.8em",
      "font-size": "28px"
    },
    on: {
      "click": function($event) {
        _vm.set_view_box = 'setOrderCheckout'
      }
    }
  }, [_vm._v("Checkout")]), _vm._v(" "), (_vm.set_view_box == '') ? _c('div', {
    staticClass: "row"
  }, [_c('h3', [_vm._v("Order List")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.set_order_list), function(item, index) {
    return _c('div', {
      staticClass: "col-xs-12 mp0 card-row-box"
    }, [_c('div', {
      staticClass: "col-xs-2 mp0"
    }, [_c('div', {
      staticStyle: {
        "height": "80px",
        "margin": "0",
        "padding": "0",
        "margin-right": "0"
      }
    }, [(item.product_item_group_image && (item.product_item_group_image != '')) ? _c('img', {
      staticClass: "card-img",
      attrs: {
        "src": item.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "card-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-10 mp0"
    }, [_c('div', {
      staticClass: "col-xs-7",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.product_name) + " "), _c('br'), _vm._v(" "), ((item.product_item_service_tag != '') && (item.product_item_service_tag != 'Nill')) ? _c('span', [_vm._v(_vm._s(item.product_item_service_tag)), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "sm-x",
      staticStyle: {
        "color": "#ff0000",
        "font-weight": "600"
      }
    }, [_vm._v("₦‎" + _vm._s(item.product_item_price_f))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "width": "39.87%"
      }
    }, [_c('div', {}, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 2, 'sub', 0, item, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 2, 'add', 0, item, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])]), _vm._v(" "), (_vm.checkOrderItems(item)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(2, item, 0, index)
        }
      }
    }, [_vm._m(8, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(2, item, 0, index)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 mp0",
      staticStyle: {
        "display": "none"
      }
    }, [_c('div', {
      staticClass: "category-slide",
      staticStyle: {
        "margin-top": "0"
      }
    }, [((Object.keys(item.product_order_options).length > 0)) ? _c('ul', {
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('a', {
      staticClass: "card-link",
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setProductOrderOptions(index, item, item.product_order_options)
        }
      }
    }, _vm._l((item.product_order_options), function(item, index) {
      return (index < 3) ? _c('li', [_c('div', {
        staticClass: "card",
        staticStyle: {
          "margin-bottom": "1em"
        }
      }, [_c('div', {
        staticClass: "card-avatar-circle",
        staticStyle: {
          "width": "35px",
          "height": "35px"
        }
      }, [(item.product_info_set_image && (item.product_info_set_image != '')) ? _c('img', {
        staticClass: "img-responsive",
        attrs: {
          "src": item.product_info_set_image
        }
      }) : _c('img', {
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })]), _vm._v(" "), _vm._m(9, true), _vm._v(" "), _c('div', {
        staticClass: "card-col-details",
        staticStyle: {
          "display": "block",
          "padding": "3px",
          "text-align": "center"
        }
      }, [_c('p', {
        staticClass: "prd-name",
        staticStyle: {
          "font-size": "16px"
        }
      }, [_vm._v(_vm._s(item.product_info_set_name) + " "), _c('br'), _vm._v(" "), (item.product_info_set_cost > 0) ? _c('span', {
        staticClass: "sm-x"
      }, [_vm._v("₦‎" + _vm._s(item.product_info_set_cost))]) : _vm._e()])])])]) : _vm._e()
    }))]) : _vm._e()])])])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderAddons') ? _c('div', {
    staticClass: "row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "0"
    }
  }, _vm._l((_vm.set_order_addons), function(product, index) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-2 card-avatar-square",
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "margin": "0",
        "padding": "0",
        "margin-right": "0"
      }
    }, [(product.product_images && (Object.keys(product.product_images).length > 0)) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_c('b', [_vm._v("Add ")]), _vm._v(_vm._s(product.product_name) + " "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x",
      staticStyle: {
        "color": "#ff0000",
        "font-weight": "600"
      }
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "width": "39.87%"
      }
    }, [_c('div', {}, [_c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.2"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 3, 'sub', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "38px"
      }
    }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
      staticStyle: {
        "padding": "0 0.61em"
      }
    }, [_vm._v(_vm._s(product.product_items[0].product_item_order_quantity))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setOrderQuantity(1, 3, 'add', index, product.product_items[0], 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "28px"
      }
    }, [_vm._v("+")])]), _vm._v(" "), (_vm.checkOrderItems(product.product_items[0])) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(3, product.product_items[0], index, 0)
        }
      }
    }, [_vm._m(11, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setAddOrderItems(3, product.product_items[0], index, 0)
        }
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])])])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setOrderCheckout"
    }
  }, [(_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setDeliveryLocation"
    }
  }, [(Object.keys(_vm.business_delivery_locations).length > 0) ? _c('div', [_vm._m(12), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_vm._l((_vm.business_delivery_locations), function(location, index) {
    return _c('div', [_c('p', [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.set_order_delivery_location),
        expression: "set_order_delivery_location"
      }],
      attrs: {
        "type": "radio"
      },
      domProps: {
        "value": location.business_delivery_option_id,
        "checked": _vm._q(_vm.set_order_delivery_location, location.business_delivery_option_id)
      },
      on: {
        "click": function($event) {
          _vm.setOrderDeliveryLocation(location)
        },
        "__c": function($event) {
          _vm.set_order_delivery_location = location.business_delivery_option_id
        }
      }
    })]), _vm._v("\r\n                    " + _vm._s(location.business_delivery_state) + " - " + _vm._s(location.business_delivery_option) + " - " + _vm._s(location.business_delivery_option_price) + "\r\n                  ")])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "setContactDetails"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Order Contact Details")]), _vm._v(" "), (_vm.user.user_id && (_vm.user.user_id > 0)) ? _c('div', [_c('p', [_vm._v("Review contact details")]), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), ((_vm.set_payment_mode == 1) && (_vm.user.user_email == '')) ? _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]) : _vm._e()]) : _c('div', [(_vm.menu_tab_inner_view['showUserDetails']) ? _c('div', [_c('p', [_c('b', [_vm._v("Name: ")]), _vm._v(_vm._s(_vm.user.user_name))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Email: ")]), _vm._v(_vm._s(_vm.user.user_email))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Phone: ")]), _vm._v(_vm._s(_vm.user.user_phone))]), _c('hr'), _vm._v(" "), _c('p', [_c('b', [_vm._v("Delivety Address: ")]), _vm._v(_vm._s(_vm.user.user_order_delivey_address))]), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('')
      }
    }
  }, [_vm._v("Reset")])])]) : _c('div', [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_name),
      expression: "user.user_name"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_email),
      expression: "user.user_email"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.user_phone),
      expression: "user.user_phone"
    }],
    staticClass: "form-control input-group-lg",
    attrs: {
      "type": "text",
      "placeholder": "Your Name"
    },
    domProps: {
      "value": (_vm.user.user_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.user_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('showUserDetails')
      }
    }
  }, [_vm._v("Ok")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.set_view_box == 'setOrderCheckout') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "setPaymentOptions"
    }
  }, [_c('div', [_vm._m(13), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "-1em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Payment Method")]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "4")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payBank')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "4"
      }
    }
  })]), _vm._v("\r\n                    Pay to Bank")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payBank"
    }
  }, [_vm._m(14), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v("Bank: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Name: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_name)), _c('br'), _vm._v(" "), _c('b', [_vm._v("Account Number: ")]), _vm._v(_vm._s(_vm.sellpoint.business_bank_details.bank_account_number))])])])]), _vm._v(" "), _c('div', [_c('p', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_payment_mode),
      expression: "set_payment_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.set_payment_mode, "1")
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('payDirect')
      },
      "__c": function($event) {
        _vm.set_payment_mode = "1"
      }
    }
  })]), _vm._v("\r\n                    Pay to Direct")]), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('div', [(_vm.data_processing_messages.mode_err) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_messages.mode_err))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.setMakeOrder(_vm.set_payment_mode)
      }
    }
  }, [_vm._v("Place Order")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "card"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('p', [_vm._v("Send Shopping List to "), _c('b', [_vm._v(_vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), _c('div', [(_vm.data_processing_messages.mode_err) ? _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_messages.mode_err))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn",
    on: {
      "click": function($event) {
        _vm.setMakeOrder(1)
      }
    }
  }, [_vm._v("Send Shopping List")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])])])]) : _vm._e()])])]) : (_vm.menu_tab_inner_view['showOrderPaymentConfirmation']) ? _c('div', [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "setPaymentSuccess"
    }
  }, [_c('p', [_vm._v("Payment Made")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "x-cta-btn card-link",
    attrs: {
      "href": '/placed/order/' + _vm.order.order_no
    }
  }, [_vm._v("View Order")])])]) : _vm._e(), _vm._v(" "), (_vm.set_order_list.length > 0) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "border": "none",
      "width": "100%",
      "bottom": "0",
      "margin": "0",
      "padding": "0 2em",
      "padding-top": "1.2em",
      "padding-right": "0",
      "background": "#ffffff",
      "z-index": "1"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "4em",
      "padding": "0.1em",
      "background-color": "rgba(0, 0, 0, 0)",
      "border-top": "none",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "x-totals"
  }, [(_vm.set_order_total_amount && (_vm.set_order_total_amount > 0)) ? _c('h3', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "x-cta-btn"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('processOrder');
      }
    }
  }, [_vm._v("Order Now>>")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%",
      "margin-left": "-0.11em"
    },
    attrs: {
      "id": "infoBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop88"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "max-height": "60vh",
      "overflow": "scroll",
      "bottom": "20vh",
      "margin": "0 -1.2em",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "z-box",
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "border-radius": "35px 35px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "60vh",
      "padding": "2em",
      "text-align": "left"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('infoBox')
      }
    }
  }, [_vm._m(17), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 1em",
      "margin-bottom": "5em"
    }
  }, [(_vm.set_view_box_2 == 'setProductOrderOptions') ? _c('div', {
    key: _vm.componentKey,
    staticClass: "row"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "card-top-right",
    staticStyle: {
      "float": "right"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "0"
    }
  }, _vm._l((_vm.set_order_list[_vm.set_order_options_item_index].product_order_options), function(option, index) {
    return _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-2 card-avatar-square",
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "margin": "0",
        "padding": "0",
        "margin-right": "0"
      }
    }, [(option.product_info_set_image && (option.product_info_set_image != '')) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": option.product_info_set_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-4",
      staticStyle: {
        "padding": "3px",
        "padding-left": "8px",
        "margin": "0",
        "text-align": "left"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(option.product_info_set_name) + " "), _c('br'), _vm._v(" "), (option.product_info_set_cost > 0) ? _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(option.product_info_set_cost))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5",
      staticStyle: {
        "margin": "0",
        "padding": "0",
        "width": "39.87%"
      }
    }, [_c('div', [_c('a', {
      staticStyle: {
        "margin-top": "-15em"
      },
      on: {
        "click": function($event) {
          _vm.setItemProductOrderOptions(option, index, _vm.product_item, _vm.set_order_options_item_index)
        }
      }
    }, [_vm._v("x")]), _vm._v("bb\r\n                        ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v(_vm._s(option.set_status))])])])])
  }))]) : _vm._e()])])])])])]) : _vm._e(), _vm._v(" "), (_vm.product && (Object.keys(_vm.product).length > 0)) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "none",
      "z-index": "10000",
      "width": "100%",
      "margin-left": "0"
    },
    attrs: {
      "id": "productBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {}
    }
  }, [_c('span', {
    staticClass: "s-backdrop88"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "90%",
      "max-height": "90vh",
      "overflow": "scroll",
      "bottom": "5vh",
      "margin": "0",
      "margin-left": "0.5em",
      "border-radius": "14px",
      "background": "#ffffff",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticClass: "z-box",
    staticStyle: {
      "width": "100%",
      "border-radius": "35px 35px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "60vh",
      "text-align": "left",
      "overflow": "scroll"
    }
  }, [_c('div', {
    staticClass: "card x-img-bg",
    staticStyle: {
      "background-repeat": "no-repeat",
      "background-size": "contain"
    },
    style: ({
      'background-image': 'url(' + _vm.product.product_images[0].product_image + ')'
    }),
    attrs: {
      "id": "dbgg"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "inherit",
      "display": "block"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('productBox')
      }
    }
  }, [_vm._m(19), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em",
      "background-color": "#eee",
      "color": "#000000",
      "border-radius": "50%"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": "0",
      "margin-bottom": "15em",
      "padding": "1em"
    }
  }, [_c('div', {
    staticClass: "card x-img-bg",
    staticStyle: {
      "background-repeat": "no-repeat",
      "background-size": "contain"
    },
    style: ({
      'background-image': 'url(' + _vm.product.product_images[0].product_image + ')'
    }),
    attrs: {
      "id": "dbgg"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.product.product_name))]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pLess"
    }
  }, [_c('span', {
    staticClass: "max-lines"
  }, [_vm._v("Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals. \r\n                Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n                Connect with them on Dribbble; the global community for designers and \r\n                creative professionals.")]), _vm._v(".."), _c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('pMore', 'pLess')
      }
    }
  }, [_vm._v("more")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "pMore"
    }
  }, [_vm._v("A Create stunning Food Delivery App designed by Lena Smirnova. \r\n                  Connect with them on Dribbble; the global community for designers and \r\n                  creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n                  Connect with them on Dribbble; the global community for designers and \r\n                  creative professionals. \r\n                  Create stunning Food Delivery App designed by Lena Smirnova. \r\n                  Connect with them on Dribbble; the global community for designers and \r\n                  creative professionals. Create stunning Food Delivery App designed by Lena Smirnova. \r\n                  Connect with them on Dribbble; the global community for designers and \r\n                  creative professionals...."), _c('a', {
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('pMore', 'pLess')
      }
    }
  }, [_vm._v("less")])])]), _vm._v(" "), (_vm.product.product_items && (Object.keys(_vm.product.product_items).length > 0)) ? _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-bottom": "15em"
    }
  }, [_c('h4', [_vm._v("Please select from (" + _vm._s(_vm.product.product_items.length) + ") below options")]), _vm._v(" "), _vm._l((_vm.product.product_items), function(item, product_item_index) {
    return _c('div', {}, [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setProductItem(item, product_item_index);
        }
      }
    }, [_c('div', {
      staticClass: "card col-xs-12 mp0",
      staticStyle: {
        "margin-bottom": "1em",
        "padding": "1em 0.5em",
        "border": "1px solid #eee",
        "border-radius": "3px"
      }
    }, [_c('div', {
      staticClass: "col-xs-1 mp0"
    }, [(_vm.checkOrderItems(item)) ? _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6"
      },
      attrs: {
        "type": "button"
      }
    }, [_vm._m(20, true)]) : _c('button', {
      staticClass: "btn sp-button-02-lt",
      staticStyle: {
        "padding": "3px 3px",
        "line-height": "0.6",
        "border": "#d8d8d8 solid"
      },
      attrs: {
        "type": "button"
      }
    }, [_c('span', {
      staticStyle: {
        "font-size": "18px"
      }
    }, [_vm._v("  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8"
    }, [_c('p', [(product_item_index == 0) ? _c('span', [_c('b', [_vm._v("Main")])]) : _c('span', [_vm._v(_vm._s(item.product_item_service_tag))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-2 mp0"
    }, [_c('p', [_vm._v("₦‎" + _vm._s(item.product_item_price_f))])])])])])
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.checkProductOrderItems(_vm.product)) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "border": "none",
      "width": "90%",
      "margin-left": "-1.2em",
      "bottom": "3.4em",
      "background-color": "#eee",
      "border-top": "#eee solid 1px",
      "z-index": "1",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "100%",
      "height": "4em",
      "padding": "0.1em",
      "background-color": "rgba(0, 0, 0, 0)",
      "border-top": "none",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [(_vm.set_order_total_amount && (_vm.set_order_total_amount > 0)) ? _c('h3', [_vm._v("₦‎" + _vm._s(_vm.formatCurrency_2(_vm.set_order_total_amount)))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "display": "block"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('p', [_c('span', {
    attrs: {
      "id": 'prdQty' + _vm.product_index
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(1, 1, 'sub', _vm.product_index, _vm.product_item, _vm.product_item_index)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "38px"
    }
  }, [_vm._v("-")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding": "0 0.61em"
    }
  }, [_vm._v(_vm._s(_vm.product_item.product_item_order_quantity))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setOrderQuantity(1, 1, 'add', _vm.product_index, _vm.product_item, _vm.product_item_index)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.checkOrderItems(_vm.product_item)) ? _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddOrderItems(1, _vm.product_item, _vm.product_index, _vm.product_item_index);
        _vm.toggleSingleComponent('prdQty' + _vm.product_index)
      }
    }
  }, [_vm._m(21)]) : _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6",
      "border": "#d8d8d8 solid"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAddOrderItems(1, _vm.product_item, _vm.product_index, _vm.product_item_index);
        _vm.toggleSingleComponent('prdQty' + _vm.product_index)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("  ")])])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "padding": "3px 3px",
      "line-height": "0.6",
      "border": "#d8d8d8 solid"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.toggleSingleComponent('productBox')
      }
    }
  }, [_vm._m(22)])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])]) : _vm._e(), _vm._v(" "), ((_vm.product.product_images && (_vm.product.product_images.length > 0)) && (_vm.product.product_images[0].product_image != '' && _vm.product.product_images[0].product_image != 'error')) ? _c('img', {
    key: _vm.componentKey,
    staticClass: "pb_img",
    staticStyle: {
      "opacity": "0"
    },
    attrs: {
      "id": "xmg",
      "src": _vm.img_product_url + _vm.product.product_images[0].product_image,
      "alt": ""
    }
  }) : _vm._e()])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "display": "none",
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "margin-top": "-15em"
    }
  }, [_vm._v("x")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._v("Add to Order"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "0.05em",
      "font-size": "13px"
    }
  }, [_vm._v("items you should buy with this order")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Delivery Locations")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-right",
    staticStyle: {
      "margin-top": "-1.4em"
    }
  }, [_c('h3', [_vm._v("Payment")]), _vm._v(" "), _c('p', [_vm._v("set where you want this order delivered to")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0.2em"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Send to:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "payDirect"
    }
  }, [_c('p', [_vm._v("Pay with your Credit/ATM card")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-left",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-shopping-bag",
    staticStyle: {
      "font-size": "3em"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "display": "none",
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-top-left",
    staticStyle: {
      "float": "left"
    }
  }, [_c('h5', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._v("Order Options"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "0.05em",
      "font-size": "13px"
    }
  }, [_vm._v("Remove items you don't want included in an order")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "display": "none",
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d81b8c0"}!./src/pages/Sellpoint/Sellpoint/template.html
// module id = 531
// module chunks = 0